import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_PROFILE_SECRET;

export const encryptProfile = ({ id, isVen }) => {
    try {
        const payload = JSON.stringify({
            id,
            isVen
        });

        return encodeURIComponent(
            CryptoJS.AES.encrypt(payload, SECRET_KEY).toString()
        )
    }
    catch (error) {
        console.error(`Profile Encryption Failed: `, error);
        return null;
    }
}

export const decryptProfile = (token) => {
    try {
        const bytes = CryptoJS.AES.decrypt(
            decodeURIComponent(token),
            SECRET_KEY
        );

        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    catch (error) {
        console.error(`Profile decryption failed: `, error);

        return {
            id: null,
            isVen: null
        }
    }
}